import type { ReactElement } from 'react';
import { cn } from '@/lib/utils';

export type FieldCharacterCountProps = {
    /** Visible counter text (e.g. "12/50 caratteri"). */
    label: string;
    id?: string;
    className?: string;
};

/**
 * Right-aligned character counter shown below a text field (Figma: current/max + unit).
 * Pair with the input via `aria-describedby={id}`.
 */
export function FieldCharacterCount({ label, id, className }: FieldCharacterCountProps): ReactElement {
    return (
        <p
            id={id}
            aria-live="polite"
            className={cn(
                'text-right text-sm leading-5 tracking-[0.14px] text-muted-foreground',
                className
            )}>
            {label}
        </p>
    );
}
